import { Component, OnInit } from '@angular/core';
import { UserLogin, User } from '../../component/model/user-login';
import { AuthServiceService } from '../../component/service/auth-service.service';
import { HttpHeaderKey, CookiesKey } from '../../shared/enum/http-header-key.enum';
import { CookiesService } from '../../shared/service/cookies/cookies.service';
import { Router} from '@angular/router';
@Component({
  selector: 'app-lock',
  templateUrl: './lock.component.html',
  styleUrls: ['./lock.component.css']
})
export class LockComponent implements OnInit {

  errorMsg : string = '';
  user : User ;
  authService : AuthServiceService;
  router: Router;
  loading : boolean = false;
  cookies : CookiesService;
  constructor(authorizationService : AuthServiceService, route :Router, cook : CookiesService ) {
    this.authService = authorizationService;
    this.router = route;
    this.cookies = cook;
    let name = this.cookies.getCookies(CookiesKey.USERNAME.toString());
    if(name===''){
      window.location.href="/#/login";
    } else {
       this.user = new User(name,'');
    }
    
   }
  
  ngOnInit() {
    $('body').addClass("login-page authentication");
  }
  login() {
    this.loading = true;
    this.errorMsg = ""; 
    this.authService.login(this.user).subscribe(data=> {window.location.href="/main";this.loading = false;}, error=> {
      this.errorMsg = JSON.parse(error._body).error_description;
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/section/lock/lock.component.ts